import { throwError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FeedbackRateType as FeedbackRatingType } from '../teacher-feedback-rate/feedback-rate-types';
import { TeacherFeedbackResponseStatus } from '../teacher-feedback-response-status/teacher-feedback-response-status';
import { PaginatedTeacherFeedbackDto } from './paginated-teacher-feedback-dto';
import { FeedbackResponseDTO } from './private-class-feedback-dto';
import { RatingAndSurveyQuestions } from './rating-and-survey-questions';
import { SelectedSurveyQuestionOptions } from './selected-survey-question-options';
import { SurveyQuestion } from './survey-question';
import { TeacherFeedbackDto } from './teacher-feedback-dto';
import { TeacherFeedbackSurveyData } from './teacher-feedback-survey-data';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { OeAppService } from '../../shared/oe-app.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
@Injectable()
export class LegacyTeacherFeedbackService {
  constructor(
    private httpClient: HttpClient,
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService
  ) {}

  getTeacherFeedback(page: number, pageSize: number) {
    const teacherFeedbackUrl = `${this.oeAppService.courseServiceHost}/v1/feedback/request/${this.oeAppPersonService.id}/${page}/${pageSize}`;
    return this.httpClient.get<PaginatedTeacherFeedbackDto>(teacherFeedbackUrl);
  }

  getPrivateclassFeedbackDetail(responseId: number): Observable<FeedbackResponseDTO> {
    const liveclassFeedbackUrl = `${this.oeAppService.courseServiceHost}/v1/liveclassfeedbacks/${responseId}`;
    return this.httpClient.get<FeedbackResponseDTO>(liveclassFeedbackUrl);
  }

  getSurveyQuestions() {
    const surveyQuestionsUrl = '/survey/teacherFeedback';
    return this.httpClient.get<TeacherFeedbackSurveyData>(surveyQuestionsUrl);
  }

  saveFeedbackRating(responseId: number, rating: FeedbackRatingType) {
    const url = `/feedback/rate/${responseId}/${rating}`;
    return this.httpClient.post(url, null, { responseType: 'text' });
  }

  saveFeedbackSurvey(responseId: number, surveyQuestions: SurveyQuestion[]) {
    const ratingBody = this.getSelectedOptionsFromQuestions(surveyQuestions);
    const url = `/survey/save/teacherFeedback/${responseId}`;
    return this.httpClient.post(url, JSON.stringify(ratingBody), {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  getRatingAndSurveyQuestions() {
    return this.getSurveyQuestions().pipe(
      map((response) => {
        const defaultNegativeFeedbackSurveyQuestionId = 250;
        const defaultRatingQuestionId = 249;
        const errorMessage = 'ERROR: The getSurveyQuestions response is not in the expected format';
        if (!response || !response.groups) {
          throw throwError(errorMessage);
        }
        const questions = response.groups[0].questions;
        const foundSurveyQuestion = questions.find((q) => q.id === defaultNegativeFeedbackSurveyQuestionId);
        const foundRatingQuestion = questions.find((q) => q.id === defaultRatingQuestionId);
        if (!foundSurveyQuestion || !foundRatingQuestion) {
          throw throwError(errorMessage);
        }
        return <RatingAndSurveyQuestions>{
          ratingQuestion: foundRatingQuestion,
          surveyQuestion: foundSurveyQuestion,
        };
      }),
      catchError((error) => {
        return error;
      })
    );
  }

  postViewedFeedback(feedbackResponseId: number) {
    const url = '/feedback/response/view/' + feedbackResponseId;
    return this.httpClient.post(url, null);
  }

  getFeedbackStatus(feedback: TeacherFeedbackDto) {
    if (!feedback.response || feedback.response.id === null) {
      return TeacherFeedbackResponseStatus.PENDING;
    }
    if (feedback.response.viewed) {
      return TeacherFeedbackResponseStatus.VIEWED;
    }
    return TeacherFeedbackResponseStatus.NEW;
  }

  getFeedbackStatusByViewed(viewed: number | null) {
    if (!!viewed) {
      return TeacherFeedbackResponseStatus.VIEWED;
    }
    return TeacherFeedbackResponseStatus.NEW;
  }

  private getSelectedOptionsFromQuestions(questions: SurveyQuestion[]): SelectedSurveyQuestionOptions[] {
    let selectedQuestionOptions: SelectedSurveyQuestionOptions[] = [];
    for (let i = 0; i < questions.length; i++) {
      const question = questions[i];
      const selectedOptions = question.options.filter((o) => o.selected);
      if (selectedOptions) {
        const parsedSelectedOptions = selectedOptions.map((so) => {
          return <SelectedSurveyQuestionOptions>{
            profileQuestionId: question.id,
            profileQuestionOptionId: so.id,
          };
        });
        selectedQuestionOptions = selectedQuestionOptions.concat(parsedSelectedOptions);
      }
    }
    return selectedQuestionOptions;
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-service/legacy-teacher-feedback.service.ts